import { ScrollArea } from "@/components/ui/scroll-area";
import { Message } from "@/types/chat";

interface MessagesListProps {
  messages: Message[];
}

export function MessagesList({ messages }: MessagesListProps) {
  return (
    <ScrollArea className="flex-1 border rounded-lg p-4">
      {messages.map((msg) => (
        <div
          key={msg.id}
          className={`mb-4 ${
            msg.role === 'user' ? 'ml-auto' : 'mr-auto'
          } max-w-[80%]`}
        >
          <div
            className={`p-3 rounded-lg ${
              msg.role === 'user'
                ? 'bg-primary text-primary-foreground'
                : 'bg-muted'
            }`}
          >
            {msg.content}
          </div>
        </div>
      ))}
    </ScrollArea>
  );
}